import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, TextField, Tooltip } from "@mui/material"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import { withStyles } from "@mui/styles"
import { useEffect, useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { Styles } from "src/styles/material-styles"
import SimpleAutoComplete from "src/components/auto-complete/autocomplete-dialog-with-z-index"
import SimpleCheckBox from "src/components/checkbox/check"
import { PapiroConsole } from "src/utils/papiroConsole"
import Api from "src/services/api"

const RagConfiguration = (props) => {
    const { classes, intl, llm, onShowNotification, onLoading } = props

    // Hoje só OpenAI está implementado. As demais opções aparecem no dropdown para
    // sinalizar o roadmap, mas vêm desabilitadas (cancreatecalled=false é a flag que o
    // SimpleAutoComplete usa internamente em getOptionDisabled).
    const embeddingprovideroptions = [
        { id: 1, name: "OpenAI", cancreatecalled: true },
        { id: 2, name: "Google (em breve)", cancreatecalled: false },
        { id: 3, name: "Azure (em breve)", cancreatecalled: false },
        { id: 4, name: "Ollama (em breve)", cancreatecalled: false },
    ]

    const [item, setItem] = useState({
        id: null,
        llmid: llm.id,
        hirerid: llm.hirerid,
        isenabled: true,
        maxchunksize: 1000,
        chunkoverlap: 200,
        embeddingmodel: "text-embedding-3-small",
        embeddingprovider: { id: 1, name: "OpenAI" },
        embeddingproviderid: 1,
        maxcontextdocuments: 5,
        similaritythreshold: 0.75,
        enablehybridsearch: true,
        vectorsearchweight: 0.7,
        textsearchweight: 0.3,
        systemprompttemplate: "",
    })

    const [restoreDialogOpen, setRestoreDialogOpen] = useState(false)

    useEffect(() => {
        getItem()
    }, [])

    useEffect(() => {
        PapiroConsole.log('item changed')
        PapiroConsole.log(item)
    }, [item])

    const getItem = async () => {
        onLoading(true)
        await Api.get(`/ragconfiguration/${llm.id}`)
            .then((response) => {
                if (response && response.data) {
                    if (response.data.data && response.data.data.id) {
                        let result = response.data.data
                        result.embeddingprovider = embeddingprovideroptions.find(option => option.id === result.embeddingprovider) || null

                        PapiroConsole.log('result get rag configuration')
                        PapiroConsole.log(result)

                        setItem(result)
                    } else {
                        setItem((prevItem) => ({
                            ...prevItem,
                            llmid: llm.id,
                            hirerid: llm.hirerid,
                            // maxchunksize: null,
                            // chunkoverlap: null,
                            // embeddingmodel: "",
                            // maxcontextdocuments: null,
                            // similaritythreshold: null,
                            enablehybridsearch: true,
                            // vectorsearchweight: null,
                            // textsearchweight: null,
                        }))
                    }
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.getting.rag.configuration" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                } 
                else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target
        setItem((prevItem) => ({
            ...prevItem,
            [name]: type === 'checkbox' ? checked : value,
        }))
    }

    const handleChangeNumber = (e) => {
        const { name, value } = e.target
        setItem((prevItem) => ({
            ...prevItem,
            [name]: value === "" ? null : Number(value),
        }))
    }

    const changeValues = (stateName, value) => {
        setItem((prevItem) => ({
            ...prevItem,
            [stateName]: value,
        }))
    }

    const openRestoreDialog = () => setRestoreDialogOpen(true)
    const closeRestoreDialog = () => setRestoreDialogOpen(false)

    // Restaurar padrão: só busca a constante do sistema e preenche o campo. Nada é gravado até o usuário clicar em Salvar.
    const restoreDefaultTemplate = async () => {
        setRestoreDialogOpen(false)
        onLoading(true)
        await Api.get('/ragconfiguration/default-system-prompt-template')
            .then((response) => {
                if (response && response.data && response.data.success) {
                    changeValues("systemprompttemplate", response.data.data ?? "")
                } else {
                    onShowNotification(intl.formatMessage({ id: "process.error" }), 'error')
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "process.error" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        onLoading(true)
        
        const formData = new FormData();
        for (let key in item) {
            if (key === "embeddingprovider") {
                formData.append("embeddingprovider", item.embeddingprovider.id)
            } else if (key === "systemprompttemplate") {
                formData.append(key, item[key] ?? "")
            } else {
                formData.append(key, item[key])
            }
        }

        await Api.put('/ragconfiguration', formData)
            .then((response) => {
                PapiroConsole.log('Rag configuration saved')
                PapiroConsole.log(response)
                onShowNotification(intl.formatMessage({ id: "rag.configuration.saved" }))
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.saving.rag.configuration" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                } 
                else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    return (
        <form className={classes.form} onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SimpleCheckBox
                        selected={item.isenabled ?? false}
                        changeSelect={changeValues}
                        name="isenabled"
                        stateName="isenabled"
                        label={intl.formatMessage({ id: "rag.enable" })}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.max-chunck-size" })}
                        name="maxchunksize"
                        stateName="maxchunksize"
                        type="number"
                        value={item.maxchunksize ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.chunck-overlap" })}
                        name="chunkoverlap"
                        stateName="chunkoverlap"
                        type="number"
                        value={item.chunkoverlap ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                    />
                </Grid>

                <Grid item xs={12}>
                    <SimpleAutoComplete
                        selected={item.embeddingprovider ?? { id: 1, name: "OpenAI" }}
                        label={intl.formatMessage({ id: "rag.embedding-provider" })}
                        name="embeddingprovider"
                        stateName="embeddingprovider"
                        changeSelect={changeValues}
                        fullWidth
                        options={embeddingprovideroptions}
                        required
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.embedding-model" })}
                        name="embeddingmodel"
                        stateName="embeddingmodel"
                        value={item.embeddingmodel ?? ""}
                        onChange={handleChange}
                        fullWidth
                        required
                        disabled
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.max-context-documents" })}
                        name="maxcontextdocuments"
                        stateName="maxcontextdocuments"
                        type="number"
                        value={item.maxcontextdocuments ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.similarity-threshold" })}
                        name="similaritythreshold"
                        stateName="similaritythreshold"
                        type="number"
                        value={item.similaritythreshold ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                        inputProps={{
                            step: "0.01",
                            inputMode: "decimal"
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <SimpleCheckBox
                        selected={item.enablehybridsearch ?? false}
                        changeSelect={changeValues}
                        name="enablehybridsearch"
                        stateName="enablehybridsearch"
                        label={intl.formatMessage({ id: "rag.enable-hybrid-search" })}
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.vector-search-weight" })}
                        name="vectorsearchweight"
                        stateName="vectorsearchweight"
                        type="number"
                        value={item.vectorsearchweight ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                        inputProps={{
                            step: "0.01",
                            inputMode: "decimal"
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.text-search-weight" })}
                        name="textsearchweight"
                        stateName="textsearchweight"
                        type="number"
                        value={item.textsearchweight ?? ""}
                        onChange={handleChangeNumber}
                        fullWidth
                        required
                        inputProps={{
                            step: "0.01",
                            inputMode: "decimal"
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={intl.formatMessage({ id: "rag.context-prompt-template" })}
                        name="systemprompttemplate"
                        stateName="systemprompttemplate"
                        value={item.systemprompttemplate ?? ""}
                        onChange={handleChange}
                        helperText={intl.formatMessage({ id: "rag.context-prompt-template.help" })}
                        placeholder={intl.formatMessage({ id: "rag.context-prompt-template.placeholder" })}
                        fullWidth
                        multiline
                        minRows={8}
                        maxRows={24}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ style: { fontFamily: "monospace", fontSize: 13 } }}
                    />
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                        <Button type="button" variant="outlined" size="small" onClick={openRestoreDialog}>
                            {intl.formatMessage({ id: "rag.context-prompt-template.restore" })}
                        </Button>
                        <Tooltip arrow placement="right" title={<span style={{ whiteSpace: 'pre-line' }}>{intl.formatMessage({ id: "rag.context-prompt-template.info" })}</span>}>
                            <IconButton size="small" aria-label="info" color="primary">
                                <InfoOutlinedIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </div>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Button
                        type='submit'
                        fullWidth
                        variant='contained'
                        color='primary'
                    >
                        {<FormattedMessage id="save" />}
                    </Button>
                </Grid>
            </Grid>
            <Dialog open={restoreDialogOpen} onClose={closeRestoreDialog} PaperProps={{ sx: { maxHeight: '90vh' } }}>
                <DialogTitle>{intl.formatMessage({ id: "rag.context-prompt-template.restore.title" })}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{intl.formatMessage({ id: "rag.context-prompt-template.restore.text" })}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button type="button" onClick={closeRestoreDialog} color="inherit">{intl.formatMessage({ id: "cancel" })}</Button>
                    <Button type="button" onClick={restoreDefaultTemplate} variant="contained" color="primary">{intl.formatMessage({ id: "confirm" })}</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}

export default injectIntl(withStyles(Styles)(RagConfiguration))